module.exports = __webpack_public_path__ + "img/bed.caac73e5.svg";